import { Drawer as MantineDrawer, DrawerProps } from '@mantine/core';

export type IDrawerProps = DrawerProps;

/** @registry Design-layer pass-through over Mantine Drawer; import this instead of @mantine/core Drawer outside src/design. Extend here when Drawer needs house behavior. */
export const Drawer = MantineDrawer;
